import React, { useState, useEffect, useContext } from 'react'; 
import { Container, Row, Col, Card } from 'react-bootstrap';
import './OurServices.css'; 
import { LandingContext } from '../Profile/LandingContext';
import DefaultData from '../../CompanyData/DefaultData';
// Your original services data (unchanged)
const services = [
    { 
        name: 'Airline Reservation & Ticketing', 
        icon: 'ri-plane-line',
        details: [
            'Access 130+ airlines worldwide with competitive fares.',
            'Exclusive travel offers for credit and debit cardholders from top banks.'
        ],
        contacts: [ { label: 'Corporate Clients', email: DefaultData?.DEFAULTCOMPANYEMAIL}, { label: 'Leisure Travellers', email: DefaultData?.DEFAULTCOMPANYEMAIL } ]
    },
    { 
        name: 'Holiday Packages', 
        icon: 'ri-suitcase-line',
        details: [ 'Customizable and value-for-money holiday packages.', 'Airport transfers, car rentals, rail, sea, and other private transport arrangements upon request.' ],
        contacts: [ { email: DefaultData?.DEFAULTCOMPANYEMAIL } ]
    },
    { 
        name: 'Meetings, Incentives & Corporate Events (M.I.C.E.)', 
        icon: 'ri-mic-2-line',
        details: [ 'Full service event planning for Product Launches, Gala Dinners, Award Nights, and Corporate Retreats.' ],
        contacts: [ { email: DefaultData?.DEFAULTCOMPANYEMAIL } ]
    },
    { 
        name: 'Online Corporate Travel Booking Portal', 
        icon: 'ri-computer-line',
        details: [ 'B2B booking tool simplifying trips for businesses of all sizes.', 'Offers crisis management, duty of care, and 24/7 support.' ],
        contacts: [ { email: DefaultData?.DEFAULTCOMPANYEMAIL } ]
    },
    { 
        name: 'Visa Application & Support', 
        icon: 'ri-passport-line',
        details: [ 'Assistance and information for all traveler, student, and business visa applications to foreign embassies.' ],
        contacts: [ { email: DefaultData?.DEFAULTCOMPANYEMAIL } ]
    },
    { 
        name: 'Premium Guided & Adventure Tours', 
        icon: 'ri-compass-3-line',
        details: [ 'Luxury Gold, Insight Vacations, Trafalgar, National Geographic Journeys, and G Adventures.' ],
        contacts: [ { email: DefaultData?.DEFAULTCOMPANYEMAIL } ]
    },
    { 
        name: 'Student Travel', 
        icon: 'ri-graduation-cap-line',
        details: [ 'Special student airfares with benefits, including assistance with extra baggage allowance and travel insurance.' ],
        contacts: [ { email: DefaultData?.DEFAULTCOMPANYEMAIL } ]
    },
    { 
        name: 'Travel Insurance', 
        icon: 'ri-shield-check-line',
        details: [ 'Comprehensive coverage for trip protection and emergency support, underwritten by leading insurance providers.' ],
        contacts: [ { email: DefaultData?.DEFAULTCOMPANYEMAIL } ]
    }
];

const OurServices = () => {
    const landingData = useContext(LandingContext);
        const pageStyles = {
            '--theme-primary-color': landingData?.themeColor1 || DefaultData?.THEMECOLOR1,
            '--theme-secondary-color': landingData?.themeColor2 || DefaultData?.THEMECOLOR2
        };

    return (
        // UPDATED: Apply the dynamic styles to the main container
        <div className="main-content" style={pageStyles}>
            <div className="services-hero-section">
                <Container className="text-center">
                    <h1 className="hero-title">Our Services</h1>
                    <p className="hero-subtitle">A complete one-stop solution for all your travel needs.</p>
                </Container>
            </div>

            <div className="page-content">
                <Container>
                    <section className="services-grid">
                        <Row className="g-4">
                            {services.map(service => (
                                <Col md={6} lg={4} key={service.name}>
                                    <Card className="h-100 service-card-detailed">
                                        <Card.Body className="d-flex flex-column">
                                            <div className="service-header">
                                                <i className={service.icon}></i>
                                                <Card.Title as="h5">{service.name}</Card.Title>
                                            </div>
                                            <hr />
                                            <ul className="service-details-list">
                                                {service.details.map((detail, index) => (
                                                    <li key={index}>{detail}</li>
                                                ))}
                                            </ul>
                                            <div className="service-contacts mt-auto">
                                                {service.contacts.map((contact, index) => (
                                                    <div key={index}>
                                                        {contact.label && <span>{contact.label}: </span>}
                                                        <a href={`mailto:${contact.email}`}>{contact.email}</a>
                                                    </div>
                                                ))}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </section>
                </Container>
            </div>
        </div>
    );
};

export default OurServices;